import ReviewsContainer from './ReviewsContainer';

export default ReviewsContainer;
